import React from 'react';
import { connect } from 'react-redux';
import { statusTingkat } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  statusTingkat,
};

function ModalStatus({ data, statusTingkat, closeModal }) {
  const auth = data?.auth;
  const history = data?.history;
  const item = data?.item;
  const screenWidth = useScreenWidth();

  function handleSetStatus() {
    const values = { ...item };
    values.status = item.status ? false : true;
    statusTingkat({ auth, history, values });
    closeModal();
  }

  return (
    <Modal
      variant='info'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        Apakah Anda ingin set tingkat{' '}
        <span className='has-text-info has-text-weight-semibold is-capitalized'>
          {item.title}
        </span>{' '}
        menjadi {item.status ? 'non aktif' : 'aktif'} ?
      </p>
      <div className='flex justify-end align-center pt-2 px-4'>
        <div className='buttons'>
          <Button cvariant='csave' onClick={handleSetStatus} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalStatus);
